__turbopack_context__.v({
  "inner_wrap": "HeadlineTitle-module-scss-module__TT5mgG__inner_wrap",
  "large": "HeadlineTitle-module-scss-module__TT5mgG__large",
  "medium": "HeadlineTitle-module-scss-module__TT5mgG__medium",
  "small": "HeadlineTitle-module-scss-module__TT5mgG__small",
  "sub_text": "HeadlineTitle-module-scss-module__TT5mgG__sub_text",
  "title": "HeadlineTitle-module-scss-module__TT5mgG__title",
  "wrap": "HeadlineTitle-module-scss-module__TT5mgG__wrap",
});
